import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import ProductsTabs from "segments/desktop/core-components/products-tabs/products-tabs";
import { componentStyles } from "./side-by-side-paragraph-and-products-tabs-component.scss";

const SideBySideParagraphAndProductsTabsComponent = ({
  fullParagraph,
  productTabs,
  paragraphAdvancedConfig,
  translate,
  minHeight,
  theme
}) => (
  <div className="side-by-side-paragraph-and-products-tabs-component" style={{ minHeight }}>
    <div className="full-paragraph-container" style={{ marginTop: fullParagraph?.marginTop }}>
      <FullParagraph {...fullParagraph} {...paragraphAdvancedConfig} />
    </div>
    <ProductsTabs translate={translate} {...productTabs} theme={theme} />
    <style jsx>{componentStyles}</style>
  </div>
);

export default SideBySideParagraphAndProductsTabsComponent;
